module.exports = __webpack_public_path__ + "static/engaged-b1e44c2b729533a56ce9edaac59caba9.png";